import React from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import eduslide1 from '../../../assets/front/img/home/eduslide-1.jpg';
import eduslide2 from '../../../assets/front/img/home/eduslide-2.jpg';
import eduslide3 from '../../../assets/front/img/home/eduslide-3.jpg';

class About extends React.Component {

    componentDidMount() {
        document.querySelector("main").scrollIntoView();
    }

    render() {
        var settings = {
            autoplay: true,
            dots: true,
            infinite: true,
            autoplaySpeed: 5000,
            slidesToShow: 1,
            slidesToScroll: 1
        };

        return (
            <div className="container">
                <div className="g-my-20">
                    <Slider {...settings}>
                        <div>
                            <img src={eduslide1} className="img-fluid mx-auto d-block" alt="" />
                        </div>
                        <div>
                            <img src={eduslide2} className="img-fluid mx-auto d-block" alt="" />
                        </div>
                        <div>
                            <img src={eduslide3} className="img-fluid mx-auto d-block" alt="" />
                        </div>
                    </Slider>
                </div>

                <div className="g-my-30">
                    <div className="row justify-content-center">
                        <div className="col col-lg-11">
                            <div className="row">
                                <div className="col-md-4">
                                    <h3 className="h4 g-font-weight-600">동물권 교육의 중요성</h3>
                                </div>
                                <div className="col-md-8">
                                    <p className="g-line-height-2">
                                        많은 사람이 우리가 살아가는 세상에서 동물이 인간으로 인해 고통받고 있다는 사실을 뉴스와 미디어를 통해 접하고 있습니다.
                                        그렇다면 우리는 동물에 대한 인간의 대우를 어떻게 개선할 수 있을까요?<br />
                                        그동안 카라는 크게 두 가지의 답을 제시해 왔습니다.
                                        하나는 동물에 대한 법정책의 변화, 다른 하나는 교육을 통한 시민들의 인식 변화입니다.
                                        그러나 법정책은 한 시대의 사회적 풍조와 시민들 간의 합의를 반영합니다.
                                        이에, 동물이 존중받는 세상으로 나아갈 수 있는 가장 근본적인 방법은 바로 ‘교육’이라고 할 수 있습니다.
                                    </p>
                                </div>
                            </div>

                            <hr />

                            <div className="row">
                                <div className="col-md-4">
                                    <h3 className="h4 g-font-weight-600">카라교육이 수행하는 역할</h3>
                                </div>
                                <div className="col-md-8">
                                    <p className="g-line-height-2">
                                        카라 동물권 교육은 동물이 처한 현실과 동물의 권리를 더 많은 시민에게 알리는 역할을 수행하고 동물에 대한 우리의 태도를 외면에서 공감으로 전환하고자 합니다.
                                        우리가 동물과 어떤 관계를 맺고 있는지 구체적인 현실을 돌아보게 하고 더 나은 삶의 방식을 알림으로써, 동물에 대한 인식 변화와 대안적 실천이 시작될 수 있는 계기를 마련합니다.<br />
                                        동물과 인간이 서로 긴밀하게 연결되어 있음을 깨닫는 순간, 우리는 비단 동물뿐 아니라 우리가 외면해온 더 많은 사회적 약자와의 연결감 또한 회복할 수 있을 것입니다.
                                        한 마리의 동물에게 연민과 책임감을 느낄 수 있는 사람은 더 많은 동물과 사람을 보살필 수 있습니다.
                                        우리가 가진 공감과 배려의 경계가 동물에게, 더 나아가 모든 생명에게 확장되는 세상을 만들기 위해, 오늘도 카라교육은 곳곳에서 시민들을 만나고 있습니다.
                                    </p>
                                </div>
                            </div>

                            <hr />

                            <div className="row">
                                <div className="col-md-4">
                                    <h3 className="h4 g-font-weight-600">카라교육이 이룬 성과</h3>
                                </div>
                                <div className="col-md-8">
                                    <p className="g-line-height-2">
                                        카라는 2012년부터 ‘찾아가는 동물보호 교육’을 실시했으며, 2013년부터 동물보호 교육을 위한 강사 양성을 진행해 왔습니다.
                                        2014년에는 교육장과 동물서적 전문 도서관을 갖춘 더불어숨센터를 서울시 마포구에 개관했습니다.<br />
                                        이후 카라의 동물권 교육 프로그램은 점차 다양화되고 체계화되어 왔으며, 카라는 지난 3년간(2016-2018) 1,040회의 교육을 통해 22,279명의 사람을 만났습니다.
                                        2019년에도 카라교육은 동물권 연속 강좌 ‘동물권 더배움’, 영상으로 동물권을 이야기하는 ‘카라 동물영화제’ 등 새로운 교육 활동을 모색 및 시도하고 있습니다.
                                    </p>
                                </div>
                            </div>

                            <hr />

                            <div className="row">
                                <div className="col-md-4">
                                    <h3 className="h4 g-font-weight-600">카라교육이 하는 일</h3>
                                </div>
                                <div className="col-md-8">
                                    <p className="g-line-height-2">
                                        현재 카라 동물권 교육은 아래와 같이 다양한 활동을 펼치고 있습니다.<br />
                                        아래에 명시된 주요 활동 외에도, 교육감 후보의 교육 정책을 모니터링 하거나 시시각각 발생하는 교육 현장 내 동물 학대에 대응하는 등
                                        동물친화적 교육이 우리 사회에 뿌리내릴 수 있도록 다방면에서 노력하고 있습니다.
                                        만5세 대상 교육 책자 제작과 배포, 아동/청소년 대상 교안과 교구 개발, 성인 대상 강좌와
                                        자료집 기획, 인문학 세미나 및 전시회와 영화제 등 지역과 연령 모두를 아우를 수 있는 교육 활동을 합니다
                                    </p>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <ul className="list-unstyled">
                                                <li><i className="g-color-blue-gradient-opacity-v1 mx-2 mb-2 fa fa-star"></i>찾아가는 동물권 교육</li>
                                                <li><i className="g-color-blue-gradient-opacity-v1 mx-2 mb-2 fa fa-star"></i>카라 더불어숨센터 내방 교육</li>
                                                <li><i className="g-color-blue-gradient-opacity-v1 mx-2 mb-2 fa fa-star"></i>지자체 협력을 통한 공교육 내 동물권 교육</li>
                                                <li><i className="g-color-blue-gradient-opacity-v1 mx-2 mb-2 fa fa-star"></i>동물권 연속 강좌 ‘동물권 더배움’</li>
                                                <li><i className="g-color-blue-gradient-opacity-v1 mx-2 mb-2 fa fa-star"></i>동물권 교육 자료 개발</li>
                                                <li><i className="g-color-blue-gradient-opacity-v1 mx-2 mb-2 fa fa-star"></i>동물 해부 실험/실습 대체 교구 대여</li>
                                                <li><i className="g-color-blue-gradient-opacity-v1 mx-2 mb-2 fa fa-star"></i>교육 현장 내 동물체험 및 동물실험 대응</li>
                                            </ul>
                                        </div>
                                        <div className="col-md-6">
                                            <ul className="list-unstyled">
                                                <li><i className="g-color-blue-gradient-opacity-v1 mx-2 mb-2 fa fa-star"></i>동물서적 전문 도서관 ‘킁킁도서관’ 운영</li>
                                                <li><i className="g-color-blue-gradient-opacity-v1 mx-2 mb-2 fa fa-star"></i>동물권 신간도서 북토크 ‘고돌북스’</li>
                                                <li><i className="g-color-blue-gradient-opacity-v1 mx-2 mb-2 fa fa-star"></i>동물권 도서 집중 리뷰 및 추천도서 안내</li>
                                                <li><i className="g-color-blue-gradient-opacity-v1 mx-2 mb-2 fa fa-star"></i>동물권 사진/그림 특별 전시</li>
                                                <li><i className="g-color-blue-gradient-opacity-v1 mx-2 mb-2 fa fa-star"></i>카라 동물영화제</li>
                                                <li><i className="g-color-blue-gradient-opacity-v1 mx-2 mb-2 fa fa-star"></i>카라 동물권 아카이브</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default About;


// WEBPACK FOOTER //
// ./src/pages/front/home/about.js